// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextButton-module__dsAccented--JMUsc,.TextButton-module__dsAccented--JMUsc *{font-weight:500}.TextButton-module__dsDefaultWeight--pKrTA,.TextButton-module__dsDefaultWeight--pKrTA *{font-weight:400}h5.TextButton-module__dsAccented--JMUsc,h5.TextButton-module__dsAccented--JMUsc *{font-weight:700}.TextButton-module__dsUnderline--kN6A_,.TextButton-module__dsUnderline--kN6A_ *{text-decoration:underline}.TextButton-module__dsAccented2--v3dfC,.TextButton-module__dsAccented2--v3dfC *{font-weight:700}.TextButton-module__dsBodyXL--fQuwf,.TextButton-module__dsBodyXL--fQuwf *{font-size:18px;line-height:27px}.TextButton-module__dsBodyLarge--qB292,.TextButton-module__dsBodyLarge--qB292 *{font-size:16px;line-height:24px}.TextButton-module__dsBody--nqunQ,.TextButton-module__dsBody--nqunQ *{font-size:14px;line-height:20px}.TextButton-module__dsBodySmall--XbJ8w,.TextButton-module__dsBodySmall--XbJ8w *{font-size:12px;line-height:18px}.TextButton-module__dsBodyXS--N2lug,.TextButton-module__dsBodyXS--N2lug *{font-size:10px;line-height:15px}.TextButton-module__dsActionLarge--r_7QA,.TextButton-module__dsActionLarge--r_7QA *{font-size:16px;line-height:18px}.TextButton-module__dsAction--au2tU,.TextButton-module__dsAction--au2tU *{font-size:14px;line-height:16px}.TextButton-module__dsActionSmall--fpF8g,.TextButton-module__dsActionSmall--fpF8g *{font-size:12px;line-height:14px}.TextButton-module__dsColumnHeadLine--erac1,.TextButton-module__dsColumnHeadLine--erac1 *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.TextButton-module__dsLightXL--KUUmu,.TextButton-module__dsLightXL--KUUmu *{font-size:120px;line-height:160px;font-weight:300}.TextButton-module__dsLightLarge--ccyrf,.TextButton-module__dsLightLarge--ccyrf *{font-size:48px;line-height:64px;font-weight:300}.TextButton-module__dsLight--yazzE,.TextButton-module__dsLight--yazzE *{font-size:32px;line-height:64px;font-weight:300}.TextButton-module__dsLightSmall--dAXG3,.TextButton-module__dsLightSmall--dAXG3 *{font-size:24px;line-height:36px;font-weight:300}.TextButton-module__dsLightXS--iDVIj,.TextButton-module__dsLightXS--iDVIj *{font-size:18px;line-height:27px;font-weight:300}button.TextButton-module__primary--xQEQu{color:#5155f5;background-color:rgba(0,0,0,0)}button.TextButton-module__primary--xQEQu:hover:not(:disabled){background-color:#e5e5fe}button.TextButton-module__primary--xQEQu:active:not(:disabled),button.TextButton-module__primary--xQEQu.TextButton-module__active--p1T97:not(:disabled){background-color:#cfd0ff}button.TextButton-module__primary--xQEQu:disabled{color:#b3b9c8}button.TextButton-module__primary--xQEQu:disabled svg{color:#b3b9c8}button.TextButton-module__primary--xQEQu svg{color:#5155f5}button.TextButton-module__secondary--FijyD{background-color:rgba(0,0,0,0);color:#5f677e}button.TextButton-module__secondary--FijyD:hover:not(:disabled){background-color:#eaecf2}button.TextButton-module__secondary--FijyD:active:not(:disabled),button.TextButton-module__secondary--FijyD.TextButton-module__active--p1T97:not(:disabled){color:#5f677e;background-color:#dce0ea}button.TextButton-module__secondary--FijyD:active:not(:disabled) svg,button.TextButton-module__secondary--FijyD.TextButton-module__active--p1T97:not(:disabled) svg{color:#5f677e}button.TextButton-module__secondary--FijyD:disabled{color:#b3b9c8}button.TextButton-module__secondary--FijyD:disabled svg{color:#b3b9c8}button.TextButton-module__secondary--FijyD svg{color:#5f677e}button.TextButton-module__tertiary--E7ynl{color:#5155f5;background-color:rgba(0,0,0,0)}button.TextButton-module__tertiary--E7ynl:not(:disabled):hover,button.TextButton-module__tertiary--E7ynl:not(:disabled):hover *{color:#3438d0;text-decoration:underline}button.TextButton-module__tertiary--E7ynl:not(:disabled):active,button.TextButton-module__tertiary--E7ynl:not(:disabled):active *,button.TextButton-module__tertiary--E7ynl:not(:disabled).TextButton-module__active--p1T97,button.TextButton-module__tertiary--E7ynl:not(:disabled).TextButton-module__active--p1T97 *{color:#262ab5;text-decoration:underline}button.TextButton-module__tertiary--E7ynl:disabled,button.TextButton-module__tertiary--E7ynl:disabled svg{color:#b3b9c8}button.TextButton-module__small--q_qGO:not(.TextButton-module__tertiary--E7ynl){padding:6px 8px;height:24px}button.TextButton-module__medium--Q5ftX:not(.TextButton-module__tertiary--E7ynl){padding:9px 12px;height:32px}button.TextButton-module__large--fi4JM:not(.TextButton-module__tertiary--E7ynl){padding:11px 14px;height:36px}button.TextButton-module__XL--LR952:not(.TextButton-module__tertiary--E7ynl){padding:13px 16px;height:42px}button.TextButton-module__leftIconPadding--G1lej.TextButton-module__small--q_qGO{padding:6px 8px}button.TextButton-module__leftIconPadding--G1lej.TextButton-module__medium--Q5ftX{padding-left:8px}button.TextButton-module__leftIconPadding--G1lej.TextButton-module__large--fi4JM{padding-left:10px}button.TextButton-module__leftIconPadding--G1lej.TextButton-module__XL--LR952{padding-left:12px}button.TextButton-module__rightIconPadding--g20rM.TextButton-module__small--q_qGO{padding:6px 8px}button.TextButton-module__rightIconPadding--g20rM.TextButton-module__medium--Q5ftX{padding-right:8px}button.TextButton-module__rightIconPadding--g20rM.TextButton-module__large--fi4JM{padding-right:10px}button.TextButton-module__rightIconPadding--g20rM.TextButton-module__XL--LR952{padding-right:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `TextButton-module__dsAccented--JMUsc`,
	"dsDefaultWeight": `TextButton-module__dsDefaultWeight--pKrTA`,
	"dsUnderline": `TextButton-module__dsUnderline--kN6A_`,
	"dsAccented2": `TextButton-module__dsAccented2--v3dfC`,
	"dsBodyXL": `TextButton-module__dsBodyXL--fQuwf`,
	"dsBodyLarge": `TextButton-module__dsBodyLarge--qB292`,
	"dsBody": `TextButton-module__dsBody--nqunQ`,
	"dsBodySmall": `TextButton-module__dsBodySmall--XbJ8w`,
	"dsBodyXS": `TextButton-module__dsBodyXS--N2lug`,
	"dsActionLarge": `TextButton-module__dsActionLarge--r_7QA`,
	"dsAction": `TextButton-module__dsAction--au2tU`,
	"dsActionSmall": `TextButton-module__dsActionSmall--fpF8g`,
	"dsColumnHeadLine": `TextButton-module__dsColumnHeadLine--erac1`,
	"dsLightXL": `TextButton-module__dsLightXL--KUUmu`,
	"dsLightLarge": `TextButton-module__dsLightLarge--ccyrf`,
	"dsLight": `TextButton-module__dsLight--yazzE`,
	"dsLightSmall": `TextButton-module__dsLightSmall--dAXG3`,
	"dsLightXS": `TextButton-module__dsLightXS--iDVIj`,
	"primary": `TextButton-module__primary--xQEQu`,
	"active": `TextButton-module__active--p1T97`,
	"secondary": `TextButton-module__secondary--FijyD`,
	"tertiary": `TextButton-module__tertiary--E7ynl`,
	"small": `TextButton-module__small--q_qGO`,
	"medium": `TextButton-module__medium--Q5ftX`,
	"large": `TextButton-module__large--fi4JM`,
	"XL": `TextButton-module__XL--LR952`,
	"leftIconPadding": `TextButton-module__leftIconPadding--G1lej`,
	"rightIconPadding": `TextButton-module__rightIconPadding--g20rM`
};
module.exports = ___CSS_LOADER_EXPORT___;
